import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import NewsletterForm from "./NewsletterForm";
import { COMPANY } from "@/lib/content";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-white/85 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img
            src="/assets/groman-logo-white.webp"
            alt="Groman Associates — Your Vision, Our Expertise"
            className="h-16 w-auto"
          />
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            Strategic HR leadership, compliance rigor, and workforce solutions for organizations
            competing in commercial and government markets.
          </p>
          <div className="mt-8 space-y-3 text-sm text-white/70">
            <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-gold" /> {COMPANY.address}</div>
            <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-gold" /> {COMPANY.email}</div>
            <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-gold" /> {COMPANY.phone}</div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="overline text-gold mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-gold transition-colors" to="/about">About Us</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/services">Services</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/government-contracting">Government Contracting</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/industries">Industries</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="overline text-gold mb-4">Groman Insights Newsletter</div>
          <p className="text-sm text-white/70 mb-4">
            Practical HR strategy, compliance, and workforce insights — delivered occasionally, never spammy.
          </p>
          <NewsletterForm />
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="font-mono tracking-[0.2em] uppercase">EIN &middot; UEI &middot; CAGE — Available on request</div>
        </div>
      </div>
    </footer>
  );
}
